<template>
  <div class="containerTable">
    <vxe-toolbar
      :id="toolbarId"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="makeMoney_search_button" @click="funcFilter()">
          查询
        </el-button>
        <el-button
          v-if="makeMoney_search_button"
          @click="batchInputDialogVisible = true"
        >
          多运单查询
        </el-button>
        <el-button
          v-if="makeMoney_batchPayment_button && shipment.isPayPermission === 1"
          @click="getSelectEvent()"
        >
          批量打款
        </el-button>
        <!-- <el-button v-if="makeMoney_reject_button" @click="getRejectEvent()">
          批量驳回
        </el-button> -->
        <el-button
          v-if="getLimit('MakeMoney_update_button')"
          @click="updataShipperPaymentResult()"
        >
          更新支付状态
        </el-button>
        <el-button
          v-if="getLimit('makeMoney_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <div style="position: absolute;top: 10px;right: 122px;">
      回单付运费合计:
      <span style="color: red;font-weight: bold;">
        {{ selectedShipmentDeliveryFeePracticalSum || "--" }}
      </span>
      &ensp; &ensp;回单付服务费合计:
      <span style="color: red;font-weight: bold;">
        {{ selectedShipmentServiceFeePracticalSum || "--" }}
      </span>
      &ensp; &ensp;实际承运人回单应收运费合计:
      <span style="color: red;font-weight: bold;">
        {{ selectedReturnAmountSum || "--" }}&ensp; &ensp;
      </span>
    </div>
    <vxe-table
      :key="tableKey"
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :loading="loading"
      :header-cell-class-name="headerCellClassName"
      :cell-class-name="cellClassName"
      :footer-method="footerMethod"
      :checkbox-config="{ highlight: true, checkMethod: checCheckboxkMethod }"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
      @checkbox-change="updateSelectedFeeSum"
      @checkbox-all="updateSelectedFeeSum"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column v-if="isSub">
        <vxe-table-column
          field="companyName"
          title="子公司名称"
          min-width="200"
          sortable
          fixed="left"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyName"
            placeholder="请输入子公司名称"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="isReceiptReturn"
          :formatter="formatterReceiptStatus"
          title="纸质回单状态"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isReceiptReturn"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in receiptOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="returnPayStatus"
          title="付款状态"
          :formatter="formatterApplyStatus"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.returnPayStatus"
            clearable
            placeholder="请选择"
            :disabled="returnPayStatus !== ''"
          >
            <el-option
              v-for="item in payShipment"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderCode"
          title="运输单号"
          min-width="250"
          sortable
        >
          <template #default="scope">
            <div class="oeder_num_box">
              <span style="margin-right: 9px;">{{ scope.row.orderCode }}</span>
              <!-- -->
              <el-tooltip content="预付单" placement="top">
                <img
                  v-if="scope.row.payType == 1"
                  class="icon_yu"
                  src="@/assets/icon/yu.png"
                  alt=""
                />
              </el-tooltip>
              <el-tooltip content="变动金额，实际承运人确认中" placement="top">
                <img
                  v-if="scope.row.isReturnPayModify === 1"
                  class="icon_yu_big"
                  src="@/assets/icon/biandonging.png"
                  alt=""
                />
              </el-tooltip>
              <el-tooltip content="无需支付，实际承运人确认中" placement="top">
                <img
                  v-if="scope.row.isReturnPayCancel === 1"
                  class="icon_yu_big"
                  src="@/assets/icon/wuxvzhifuing.png"
                  alt=""
                />
              </el-tooltip>
            </div>
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCode"
            placeholder="请输入运输单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentActualCash"
          title="回单付款费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentActualCashStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentActualCashEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="returnTaxFee"
          title="回单付款服务费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.returnTaxFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.returnTaxFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入货源单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 项目信息 -->
      <vxe-table-column>
        <vxe-table-column
          field="sourceOrderNumber"
          title="来源单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.sourceOrderNumber"
            placeholder="请输入来源单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="projectName"
          title="项目名称"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.projectName"
            placeholder="请输入项目名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lineName"
          title="线路简称"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.lineName"
            placeholder="请输入线路简称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="dfName"
          title="经办人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.dfName"
            placeholder="请输入经办人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentName"
          title="托运人名称"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentName"
            placeholder="请输入托运人名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="ordCreatedByPhone"
          title="托运人电话"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.ordCreatedByPhone"
            placeholder="请输入托运人电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentStaffTypeStr"
          title="托运人类型"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.shipmentStaffType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in shipmentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="companyName"
          title="托运人"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyName"
            placeholder="请输入托运人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isMonthlyOrder"
          title="结算类型"
          min-width="100"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'isMonthlyOrder')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isMonthlyOrder"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.isMonthlyOrderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipmentPayFailReasons"
          title="失败原因"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentPayFailReasons"
            placeholder="请输入失败原因"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalTypeName"
          title="货物名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalTypeName"
            placeholder="请输入货物名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalPrice"
          title="货物单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.coalPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.coalPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalName"
          title="运输要求"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalName"
            placeholder="请输入运输要求"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfShipment"
          title="装货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfShipment"
            placeholder="请输入装货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="loadPlace"
          title="实际操作装货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.loadPlace"
            placeholder="请输入实际操作装货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfReceipt"
          title="卸货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfReceipt"
            placeholder="请输入卸货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="unloadPlace"
          title="实际操作卸货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.unloadPlace"
            placeholder="请输入实际操作卸货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="distance"
          title="里程数(公里)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.distanceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.distanceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="teamName"
          title="车队名称"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.teamName"
            placeholder="请输入车队名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="实际承运人姓名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入实际承运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverPhone"
          title="实际承运人电话"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            placeholder="请输入实际承运人电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicense"
          title="车牌号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicense"
            placeholder="请输入车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="weight"
          title="接单数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.weightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.weightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="loadQuantity"
          title="装货数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.loadQuantityStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.loadQuantityEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="unloadQuantity"
          title="卸货数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.unloadQuantityStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.unloadQuantityEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="wastage"
          title="货物损耗"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.wastageStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.wastageEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="settlementWeight"
          title="结算吨位"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.settlementWeightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.settlementWeightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="maxPrice"
          title="最高价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.maxPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.maxPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="taxPrice"
          title="托运人成交单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="taxFee"
          title="托运人预估运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="payAmount"
          title="托运人预付运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.payTaxAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.payTaxAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- TODO: -->
      <vxe-table-column>
        <vxe-table-column
          field="shipperDeliveryFee"
          title="到付款费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipperDeliveryFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipperDeliveryFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="taxPayFee"
          title="到付款服务费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPayFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPayFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="allTaxFee"
          title="总服务费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.allTaxFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.allTaxFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- end -->
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipmentDeliveryFeePractical"
          title="托运人应付运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentDeliveryFeePracticalStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentDeliveryFeePracticalEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipmentActualFreight"
          title="托运人实付运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentActualFreightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentActualFreightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipmentActualCash"
          title="托运人实付现金(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentActualCashStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentActualCashEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipperDeliveryFee"
          title="托运人合计付款(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipperDeliveryFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipperDeliveryFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <!-- 实际承运人应收运费  -->
      <vxe-table-column>
        <vxe-table-column
          field="returnAmount"
          title="实际承运人回单应收运费"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.returnAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.returnAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="taxPayFee"
          title="服务费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPayFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPayFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="realPrice"
          title="实际承运人承运单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.realPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.realPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="deliveryFeeDeserved"
          title="实际承运人预估运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryFeeDeservedStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryFeeDeservedEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="platformPrepayment"
          title="平台预付运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.platformPrepaymentStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.platformPrepaymentEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="deliveryFeePractical"
          title="实际承运人应收运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryFeePracticalStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryFeePracticalEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="driverActualFreight"
          title="实际承运人实收运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.driverActualFreightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.driverActualFreightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="driverActualCash"
          title="实际承运人实收现金(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.driverActualCashStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.driverActualCashEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="deliveryCashFee"
          title="实际承运人合计收款(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryCashFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryCashFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="extraFee"
          title="其他费用(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.extraFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.extraFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="abnormalFee"
          title="异常费用(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.abnormalFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.abnormalFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column v-if="isAdmin">
        <vxe-table-column field="payOil" title="平台预付油点(元)" min-width="200" sortable />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input v-model="listQuery.payOilStart" type="number" placeholder="下限" clearable />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input v-model="listQuery.payOilEnd" type="number" placeholder="上限" clearable />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <vxe-table-column v-if="isAdmin">
        <vxe-table-column
          field="payAmount"
          title="平台预付现金(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.payAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.payAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column field="allotOil" title="已分配油费(元)" min-width="200" sortable />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input v-model="listQuery.allotOilStart" type="number" placeholder="下限" clearable />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input v-model="listQuery.allotOilEnd" type="number" placeholder="上限" clearable />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="接单时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastLoadingTime"
          title="截止装车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.lastLoadingTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'lastLoadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="fillTime"
          title="装车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.fillTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'fillTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastUnloadingTime"
          title="截止卸车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.lastUnloadingTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'lastUnloadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="signTime"
          title="卸车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.signTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'signTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="settleTime"
          title="核算时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.settleTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'settleTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtModified"
          title="最后操作时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtModifiedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtModified')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isAdmin">
        <vxe-table-column
          field="modifiedByName"
          title="最后操作人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.modifiedByName"
            placeholder="最后操作人"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column title="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="makeMoney_detail_button"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="handleClick(scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <!-- <el-tooltip
            v-if="makeMoney_reject_button"
            class="item"
            effect="dark"
            content="驳回"
            placement="top"
          >
            <vxe-button type="text" @click="funcReject(scope.row.code)">
              <i class="el-icon-back" />
            </vxe-button>
          </el-tooltip> -->
          <el-tooltip
            v-if="
              makeMoney_payment_button &&
                returnPayStatus === 0 &&
                shipment.isPayPermission === 1 &&
                ((shipment.staffType !== 10 && isSub) || !isSub)
            "
            class="item"
            effect="dark"
            content="打款"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="
                businessClick(
                  scope.row.code,
                  scope.row.paymentType,
                  scope.row.ordCreatedByPhone,
                  scope.row
                )
              "
            >
              <i class="el-icon-coin" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="MakeMoney_update_button && scope.row.shipmentPayStatus == 1"
            class="item"
            effect="dark"
            content="更新支付状态"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="updataShipperPaymentResult(scope.row)"
            >
              <i class="el-icon-refresh" />
            </vxe-button>
          </el-tooltip>
          <!--  无需支付  -->
          <el-tooltip
            v-if="
              getLimit('makeMoney_nopay_button_returnPay') &&
                shipment.isPayPermission === 1
            "
            class="item"
            effect="dark"
            content="无需支付"
            placement="top"
          >
            <vxe-button
              v-if="
                scope.row.isReceiptReturn == '2' &&
                  scope.row.returnPayStatus === 0
              "
              type="text"
              @click="handledriverCancelReturnPayApi(scope.row.code, scope.row)"
            >
              <!-- <i class="el-icon-refresh" /> -->
              <img
                style="width: 14px; height: 14px;"
                src="@/assets/icon/nopay.png"
                alt=""
              />
            </vxe-button>
          </el-tooltip>
          <!-- 变动金额 -->
          <el-tooltip
            v-if="
              getLimit('makeMoney_nopay_button_returnPay') &&
                shipment.isPayPermission === 1
            "
            class="item"
            effect="dark"
            content="变动金额"
            placement="top"
          >
            <vxe-button
              v-if="
                scope.row.isReceiptReturn == '2' &&
                  scope.row.returnPayStatus === 0 &&
                  scope.row.isReturnPayCancel !== 1
              "
              type="text"
              @click="handleChangeReturnPayApi(scope.row.code, scope.row)"
            >
              <!-- <i class="el-icon-refresh" /> -->
              <img
                style="width: 14px; height: 14px;"
                src="@/assets/icon/biandong.png"
                alt=""
              />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="details"
      title="查看订单详情"
      width="1000"
      height="600"
      resize
    >
      <accounting ref="detailRef" />
    </vxe-modal>
    <vxe-modal v-model="actionFlag" title="打款确认" width="600" resize>
      <paymentAction
        v-if="actionFlag"
        ref="actionRef"
        @closeWindows="receive"
        @error="actionFlag = false"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
    <!-- 支付密码输入 -->
    <!-- <vxe-modal v-model="showPay" title="支付" width="400" height="360" resize>
      <payPassword @complete="completePsw"></payPassword>
    </vxe-modal> -->
    <vxe-modal
      v-model="showNoPay"
      title="无需支付"
      width="600"
      height="260"
      resize
      remember
    >
      <div v-if="showNoPay" style="margin-top:10px">
        <el-form>
          <el-form-item label="取消原因">
            <el-input v-model="shipperDealRemark" type="textarea" :row="3" />
          </el-form-item>
        </el-form>
        <div style="text-align: right;margin-top:10px">
          <el-button type="primary" @click="driverCancelReturnPayApi"
            >确定</el-button
          >
        </div>
      </div>
    </vxe-modal>
    <!-- 变动金额弹窗 -->
    <vxe-modal v-model="showModifyAmount" title="变动金额" width="600" resize>
      <div class="modify-amount-content">
        <p class="original-amount">
          原回单付款金额:{{ oldshipmentActualCash.shipmentActualCash }}元
          (回单付:{{
            oldshipmentActualCash.shipmentActualCash -
              oldshipmentActualCash.returnTaxFee
          }}元 服务费:{{ oldshipmentActualCash.returnTaxFee }}元)
        </p>
        <el-form class="modify-form">
          <el-form-item label="最终回单付金额（不含服务费）">
            <el-input
              v-model="newReturnAmount"
              type="number"
              placeholder="请输入变动金额"
            />
          </el-form-item>
          <el-form-item label="变动原因">
            <el-input
              v-model="modifyRemark"
              type="textarea"
              :row="3"
              placeholder="请输入变动原因"
            />
          </el-form-item>
        </el-form>
        <div class="form-actions">
          <el-button @click="showModifyAmount = false">取消</el-button>
          <el-button type="primary" @click="confirmModifyAmount"
            >确定</el-button
          >
        </div>
      </div>
    </vxe-modal>
    <el-dialog
      title="批量输入运单号"
      :visible.sync="batchInputDialogVisible"
      width="650px"
      height="900px"
      class="batch-input-dialog"
    >
      <BatchWaybill
        :codes="listQuery.orderCode"
        @confirmBatchInput="confirmBatchInput"
      />
    </el-dialog>
  </div>
</template>
<script>
import BatchWaybill from "@/components/BatchWaybill";
import payPassword from "./components/payPassword";
import {
  orderDetailListAll,
  querySubList,
  financeReject,
  reportHubeiTransportFund,
  driverCancelReturnPay,
  adCancelReturnPay,
  shipperModifyReturnPayAmount
} from "@/api/transport";
import {
  shipperPaymentSure,
  queryShipperPaymentResult
} from "@/api/InternetBanking";
import accounting from "@/components/WaybillDetails";
import paymentAction from "./components/paymentAction";
import request from "@/utils/request";
import { getLimit } from "@/utils/getLimit.js";
export default {
  components: {
    accounting,
    paymentAction,
    payPassword,
    BatchWaybill
  },
  props: {
    returnPayStatus: {
      type: [Number, String],
      default: ""
    }
  },
  data() {
    return {
      oldshipmentActualCash: {},
      shipment: this.$store.getters.shipment || { isPayPermission: 1 },
      returnCode: "",
      showNoPay: false,
      showModifyAmount: false,
      shipperDealRemark: "",
      modifyRemark: "",
      newReturnAmount: "",
      selectedShipmentDeliveryFeePracticalSum: 0,
      selectedShipmentServiceFeePracticalSum: 0,
      selectedReturnAmountSum: 0,
      showPay: false,
      exportObj: {
        exportUrl: "/ntocc-tms-api/orderDetail/exportMakeMoney", //导出接口
        name: "托运人打款"
      },
      partyType: this.$store.getters.party.partyType,
      message: "",
      leitype: "",
      business: false,
      details: false,
      reject: false,
      loading: false,
      makeMoney_search_button: false, //查询
      makeMoney_batchPayment_button: false, //批量打款
      makeMoney_detail_button: false, //详情
      makeMoney_reject_button: false, //驳回
      makeMoney_payment_button: false, //打款
      MakeMoney_update_button: false, // 更新支付状态
      tableData: [],
      parentData: {
        isMonthlyOrderOptions: []
      },
      parentMsg: "",
      acclist: [],
      options: [
        {
          value: "1",
          label: "已接单"
        },
        {
          value: "2",
          label: "已装货"
        },
        {
          value: "3",
          label: "已卸货"
        },
        {
          value: "4",
          label: "已结算"
        },
        {
          value: "5",
          label: "已打款"
        }
      ],
      shipmentOptions: [
        { label: "个体托运人", value: 0 },
        { label: "企业托运人", value: 1 }
      ],
      receiptOptions: [
        {
          value: "0",
          label: "未收取"
        },
        {
          value: "1",
          label: "已收取"
        },
        {
          value: "2",
          label: "已签收"
        }
      ],
      // 支付状态
      payOptions: [
        {
          label: "未支付",
          value: 0
        },
        {
          label: "处理中",
          value: 1
        },
        {
          label: "已支付",
          value: 2
        },
        {
          label: "已失败",
          value: 3
        }
      ],
      // 托运人支付
      payShipment: [
        {
          label: "待打款",
          value: 0
        },
        {
          label: "打款中",
          value: 1
        },
        {
          label: "已打款",
          value: 2
        }
      ],
      value: "",
      listQuery: {
        gmtCreatedRange: "",
        lastLoadingTimeRange: "",
        fillTimeRange: "",
        lastUnloadingTimeRange: "",
        signTimeRange: "",
        settleTimeRange: "",
        gmtModifiedRange: "",
        pageNum: 1,
        pageSize: 20,
        total: 0,
        isSettle: 1,
        deleted: 0,
        // status: 5,
        shipType: "returnPay", //支付状态
        greaterStatus: 4
      },
      sumObject: {},
      // 机构列表
      branchList: this.$store.state.components.branchList,
      actionFlag: false,
      // 是否admin
      isAdmin: false,
      isShipment: false,
      isShipmentOrAdmin: false,
      isDriverOrAdmin: false,
      payInfo: null,
      batchInputDialogVisible: false
    };
  },
  computed: {
    isSub() {
      return this.$route.path.includes("sub_returnPayFee");
    },
    toolbarId() {
      const path = (this.$route.path || "").replace(/\//g, "_");
      return `toolbar_tableReturn${path ? "_" + path : ""}_${
        this.returnPayStatus === "" ? "all" : this.returnPayStatus
      }`;
    },
    tableKey() {
      return `tableReturn_${(this.$route.fullPath || "").replace(
        /[/?=&]/g,
        "_"
      )}_${this.returnPayStatus === "" ? "all" : this.returnPayStatus}`;
    }
  },
  watch: {
    "$route.fullPath"(newVal, oldVal) {
      if (newVal === oldVal) return;
      this.listQuery = {
        gmtCreatedRange: "",
        lastLoadingTimeRange: "",
        fillTimeRange: "",
        lastUnloadingTimeRange: "",
        signTimeRange: "",
        settleTimeRange: "",
        gmtModifiedRange: "",
        pageNum: 1,
        pageSize: 20,
        total: 0,
        isSettle: 1,
        deleted: 0,
        // status: 5,
        shipType: "returnPay", //支付状态
        greaterStatus: 4,
        returnPayStatus: 0
      };
      this.selectedShipmentDeliveryFeePracticalSum = 0;
      this.selectedShipmentServiceFeePracticalSum = 0;
      this.selectedReturnAmountSum = 0;
      this.$nextTick(() => {
        const table = this.$refs.xTable;
        if (!table) return;
        if (table.clearSort) table.clearSort();
        if (table.clearCheckboxRow) table.clearCheckboxRow();
      });
      this.findList();
    }
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    const isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.isAdmin = isAdmin;
    this.isShipment =
      partyType == "SHIPMENT" || partyType == "SHIPMENT_COMPANY";
    this.isShipmentOrAdmin =
      partyType == "SHIPMENT" || partyType == "SHIPMENT_COMPANY" || isAdmin;
    this.isDriverOrAdmin =
      partyType == "DRIVER" || partyType == "DRIVER_LEADER" || isAdmin;
    this.parentData.isMonthlyOrderOptions = [
      { label: "次结", value: 0 },
      { label: "月结", value: 1 }
    ];
    this.listQuery.returnPayStatus = this.returnPayStatus;
    this.findList();
    this.makeMoney_search_button = getLimit("makeMoney_search_button");
    this.makeMoney_batchPayment_button = getLimit(
      "makeMoney_batchPayment_button"
    );
    this.makeMoney_detail_button = getLimit("makeMoney_detail_button");
    this.makeMoney_reject_button = getLimit("makeMoney_reject_button");
    this.makeMoney_payment_button = getLimit("makeMoney_payment_button");
    this.MakeMoney_update_button = getLimit("MakeMoney_update_button");
  },

  methods: {
    confirmBatchInput(parsedOrderCodes) {
      if (parsedOrderCodes.length > 300) {
        this.$message.warning("运单号数量不能超过300个");
        return;
      }
      this.listQuery.orderCode = parsedOrderCodes.join(",");
      this.batchInputDialogVisible = false;
      this.funcFilter();
    },
    handleChangeReturnPayApi(code, row) {
      if (row.isReturnPayCancel === 1) {
        this.$message({
          message: "等待实际承运人确认取消打款中，请勿操作",
          type: "warning"
        });
        return;
      }
      if (row.isReturnPayModify === 1) {
        this.$message({
          message: "等待实际承运人确认变动金额中",
          type: "warning"
        });
        return;
      }
      // this.showNoPay = true;
      this.oldshipmentActualCash = row;
      this.showModifyAmount = true;
      this.returnCode = code;
    },
    handledriverCancelReturnPayApi(code, row) {
      if (row.isReturnPayModify === 1) {
        this.$message({
          message: "等待实际承运人确认变动金额中，请勿操作",
          type: "warning"
        });
        return;
      }
      if (row.isReturnPayCancel === 1) {
        this.$message({
          message: "等待实际承运人确认取消打款中",
          type: "warning"
        });
        return;
      }
      this.showNoPay = true;
      // this.showModifyAmount = true;
      this.returnCode = code;
    },
    confirmModifyAmount() {
      if (!this.modifyRemark) {
        this.$message({ message: "请输入变动原因", type: "warning" });
        return;
      }
      if (!this.newReturnAmount) {
        this.$message({ message: "请输入变动金额", type: "warning" });
        return;
      }
      if (+this.newReturnAmount < 0 || +this.newReturnAmount === 0) {
        this.$message({ message: "变动金额大于0", type: "warning" });
        return;
      }
      this.$confirm("确认要修改回单付金额吗？").then(_ => {
        shipperModifyReturnPayAmount({
          code: this.returnCode,
          newReturnAmount: this.newReturnAmount,
          modifyRemark: this.modifyRemark
        }).then(response => {
          this.modifyRemark = "";
          this.newReturnAmount = "";
          this.$message({ message: response.msg, type: "success" });
          this.showModifyAmount = false;
          this.findList();
        });
      });
    },
    driverCancelReturnPayApi() {
      this.$confirm("确认要取消打款吗？").then(_ => {
        if (!this.shipperDealRemark) {
          this.$message({ message: "请输入取消原因", type: "warning" });
          return;
        }
        let api = this.isAdmin ? adCancelReturnPay : driverCancelReturnPay;
        let remark = {};
        if (this.isAdmin) {
          remark = {
            adminRemark: this.shipperDealRemark
          };
        } else {
          remark = {
            shipperDealRemark: this.shipperDealRemark
          };
        }
        api({
          code: this.returnCode,
          isCancelReturnPay: 1,
          ...remark
        }).then(response => {
          this.shipperDealRemark = "";
          this.$message({ message: response.msg, type: "success" });
          this.showNoPay = false;
          this.findList();
        });
      });
    },

    checCheckboxkMethod({ row }) {
      return (
        row.isReceiptReturn == "2" &&
        row.returnPayStatus === 0 &&
        (row.isReturnPayCancel !== 1 && row.isReturnPayCancel !== 2)
      );
    },
    noPay(row) {
      this.$message({ message: "敬请期待", type: "warn" });
    },
    updateSelectedFeeSum() {
      const records = this.$refs.xTable
        ? this.$refs.xTable.getCheckboxRecords()
        : [];
      this.selectedShipmentDeliveryFeePracticalSum = this.$XEUtils
        ? this.$XEUtils.sum(records, "shipmentActualCash")
        : records.reduce(
            (acc, r) => acc + Number(r.shipmentActualCash || 0),
            0
          );
      this.selectedShipmentServiceFeePracticalSum = this.$XEUtils
        ? this.$XEUtils.sum(records, "returnTaxFee")
        : records.reduce((acc, r) => acc + Number(r.returnTaxFee || 0), 0);
      this.selectedReturnAmountSum = this.$XEUtils
        ? this.$XEUtils.sum(records, "returnAmount")
        : records.reduce((acc, r) => acc + Number(r.returnAmount || 0), 0);
    },
    funcReject(codes) {
      this.$confirm("确认驳回？").then(_ => {
        const rLoading = this.openLoading();
        financeReject({ codes }).then(response => {
          rLoading.close();
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        });
      });
    },
    handleClick(c) {
      this.details = true;
      this.$refs.detailRef.Getdetails(c);
    },
    businessClick(codes, paymentType, shipperPhone, row) {
      console.log("打款=========", codes, paymentType, shipperPhone, row);
      if (row && row.isReceiptReturn !== "2") {
        this.$message({
          message: "请前往【运单管理-回单签收】菜单页面，进行回单签收",
          type: "warn"
        });
        return;
      }
      if (paymentType == "arpa") {
        this.realpay(codes);
        return;
      }

      let data = {
        codes: codes
      };
      this.preApplicationForPayment(codes, paymentType, shipperPhone);
      return;
      //查询是否存在支付密码
      request({
        url: `/ntocc-basic-api/pay/isexist`,
        method: "get",
        params: data
      }).then(res => {
        if (res.status == 0 && res.data.isHave == "1") {
          this.payInfo = { codes, paymentType, shipperPhone };
          this.showPay = true;
          rLoading.close();
          return;
        } else {
          rLoading.close();
          this.$confirm("您还未设置支付密码，请前往设置", "提示", {
            confirmButtonText: "去设置",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              this.$router.push({
                path: "/systemManage/payPassword/addPassword"
              });
            })
            .catch(() => {});
        }
      });
    },
    completePsw() {
      // this.showPay = false;
      // const { codes, paymentType, shipperPhone } = this.payInfo;
      // this.preApplicationForPayment(codes, paymentType, shipperPhone);
    },
    preApplicationForPayment(codes, paymentType, shipperPhone) {
      let data = {
        codes: codes
      };
      // 判断支付方式
      const rLoading = this.openLoading();
      request({
        url: `/ntocc-tms-api/orderDetail/preApplicationForReturn`,
        method: "post",
        params: data
      }).then(response => {
        if (response.status == 0) {
          rLoading.close();
          this.actionFlag = true;

          this.$nextTick(() => {
            this.$refs.actionRef.init(response, shipperPhone, codes);
          });
        }
      });
      rLoading.close();
    },
    getSelectEvent() {
      const checkedRowArray = this.$refs.xTable.getCheckboxRecords();
      console.log("checkedRowArray", checkedRowArray);
      let branchCode = checkedRowArray[0].branchCode;
      let shipmentCode = checkedRowArray[0].shipmentCode;
      let paymentType = checkedRowArray[0].paymentType;
      let isExist = checkedRowArray.some(item => item.isReceiptReturn !== "2");
      if (isExist) {
        this.$message({
          message:
            "存在未签收的运单，请前往【运单管理-回单签收】菜单页面，进行回单签收",
          type: "warn"
        });
        return;
      }
      if (checkedRowArray.length === 0) {
        this.$message({ message: "请选择订单", type: "warning" });
      } else if (checkedRowArray.length > 100) {
        this.$message({ message: "批量处理最多100条数据", type: "warning" });
      } else {
        let arrcarcode = [];
        for (let subItem of checkedRowArray) {
          if (paymentType == "arpa" && subItem.branchCode != branchCode) {
            this.$message.warning("请选择同一机构");
            return false;
          }
          if (paymentType == "arpa" && subItem.shipmentCode != shipmentCode) {
            this.$message.warning("请选择同一托运人");
            return false;
          }
          arrcarcode.push(subItem.code);
        }
        let codes = arrcarcode.join(",");
        if (paymentType == "arpa") {
          this.realpay(codes);
        } else {
          this.businessClick(codes);
        }
      }
    },

    // 确认提示
    realpay(codes) {
      this.$confirm("确认要打款吗？")
        .then(_ => {
          this.payclick(codes);
        })
        .catch(_ => {});
    },
    async payclick(codes) {
      const rLoading = this.openLoading();
      let response = await shipperPaymentSure({ codes });
      rLoading.close();
      this.$message.success(response.msg);
      this.findList();
    },
    getRejectEvent() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (selectRecords.length === 0) {
        this.$message({ message: "请选择订单", type: "warning" });
      } else if (selectRecords.length > 20) {
        this.$message({ message: "批量处理最多20条数据", type: "warning" });
      } else {
        const arrcarcode = selectRecords.map(item => {
          return item.code;
        });
        let codes = arrcarcode.join(",");
        this.funcReject(codes);
      }
    },
    updataShipperPaymentResult(item) {
      const selectRecords = item
        ? [item]
        : this.$refs.xTable.getSelectRecords();
      if (selectRecords.length === 0) {
        this.$message({ message: "请选择订单", type: "warning" });
      } else if (selectRecords.length > 20) {
        this.$message({ message: "批量处理最多20条数据", type: "warning" });
      } else {
        const rLoading = this.openLoading();
        const arrcarcode = selectRecords.map(item => {
          return item.code;
        });
        let codes = arrcarcode.join(",");
        if (codes) {
          queryShipperPaymentResult({ codes }).then(res => {
            this.$message({ message: res.msg, type: "success" });
            this.findList();
            rLoading.close();
          });
        } else {
          this.$message({
            type: "warning",
            message: "暂无可更新的运单"
          });
        }
      }
    },
    receive() {
      this.actionFlag = false;
      this.findList();
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        // 子公司运单管理
        let api = this.$route.path.includes("sub_returnPayFee")
          ? querySubList
          : orderDetailListAll;
        api(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.tableData.forEach(item => {
            item.taxPrice = item.taxPrice + item.isTrunkName;
            item.price = item.price + item.isTrunkName;
            item.realPrice = item.realPrice + item.isTrunkName;
            item.coalPrice = item.coalPrice + "元/" + item.coalUnitName;
            item.maxPrice = item.maxPrice + item.isTrunkName;
            item.weight = item.weight + item.coalUnitName;
            item.loadQuantity = item.loadQuantity + item.coalUnitName;
            item.unloadQuantity = item.unloadQuantity + item.coalUnitName;
          });
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    //状态翻译
    formatterReceiptStatus({ cellValue }) {
      switch (cellValue) {
        case "0":
          return "未收取";
        case "1":
          return "已收取";
        case "2":
          return "已签收";
        default:
          break;
      }
    },
    // 支付状态翻译
    formatterPayStatus({ cellValue }) {
      const item = this.payOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 托运人支付状态翻译
    formatterApplyStatus({ cellValue, row }) {
      if (row.isReturnPayCancel === 1) {
        return "待确认";
      }
      if (row.isReturnPayCancel === 2) {
        return "已打款";
      }
      switch (cellValue) {
        case 0:
          return "待打款";
        case 1:
          return "打款中";
        case 2:
          return "已打款";
        default:
          break;
      }
      // const item = this.payShipment.find(item => item.value === cellValue);
      // return item ? item.label : "";
    },
    headerCellClassName({ column, columnIndex }) {
      if (column.property === "name") {
        return "col-blue";
      }
    },
    cellClassName({ row, rowIndex, column, columnIndex }) {
      if (column.property === "status") {
        switch (row.status) {
          case 0:
            return "col-red";
          case 1:
            return "col-green";
          case 2:
            return "col-orange";
          case 3:
            return "col-red";
          case 4:
            return "col-green";
          case 5:
            return "col-orange";

          default:
            break;
        }
      }
    },
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        cell => cell.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterStatus({ cellValue }) {
      switch (cellValue) {
        case 1:
          return "已接单";
        case 2:
          return "已装货";
        case 3:
          return "已卸货";
        case 4:
          return "已结算";
        case 5:
          return "已打款";

        default:
          break;
      }
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (
            [
              "shipmentActualFreight",
              "payTaxAmount",
              "driverActualFreight",
              "shipmentActualCash",
              "shipmentDeliveryFeePractical",
              "platformPrepayment",
              "driverActualCash",
              "extraFee",
              "abnormalFee",
              "payOil",
              "payAmount",
              "allotOil"
            ].includes(column.property)
          ) {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "shipperDeliveryFee") {
            return this.sumObject.shipperDeliveryFee;
          }
          if (column.property === "deliveryFeePractical") {
            return this.sumObject.deliveryFeePractical;
          }
          if (column.property === "deliveryCashFee") {
            return this.sumObject.deliveryCashFee;
          }
          if (column.property === "taxFee") {
            return this.sumObject.taxFee;
          }
          if (column.property === "taxPayFee") {
            return this.sumObject.taxPayFee;
          }
          if (column.property === "distance") {
            return this.sumObject.distance;
          }
          if (column.property === "deliveryOilFee") {
            return this.sumObject.deliveryOilFee;
          }
          if (column.property === "deliveryFeeDeserved") {
            return this.sumObject.deliveryFeeDeserved;
          }
          if (column.property === "weight") {
            return (
              this.sumObject.ton +
              "吨//" +
              this.sumObject.cubicMeter +
              "方//" +
              this.sumObject.pieces +
              "件"
            );
          }
          if (column.property === "loadQuantity") {
            return (
              this.sumObject.loadQuantityTon +
              "吨//" +
              this.sumObject.loadQuantityCubicMeter +
              "方//" +
              this.sumObject.loadQuantityPieces +
              "件"
            );
          }
          if (column.property === "wastage") {
            return (
              this.sumObject.wastageTon +
              "吨//" +
              this.sumObject.wastageCubicMeter +
              "方//" +
              this.sumObject.wastagePieces +
              "件"
            );
          }

          if (column.property === "unloadQuantity") {
            return (
              this.sumObject.unloadQuantityTon +
              "吨//" +
              this.sumObject.unloadQuantityCubicMeter +
              "方//" +
              this.sumObject.unloadQuantityPieces +
              "件"
            );
          }
          if (column.property === "settlementWeight") {
            return (
              this.sumObject.settlementWeightTon +
              "吨//" +
              this.sumObject.settlementWeightCubicMeter +
              "方//" +
              this.sumObject.settlementWeightPieces +
              "件"
            );
          }
          return "-";
        })
      ];
    }
  }
};
</script>
<style>
.checkbox-table.vxe-table .vxe-body--row.row-checked {
  background-color: #fbf8ec;
}

.vxe-footer--row .col-blue {
  background-color: rgb(233, 20, 20);
  color: #fff;
}

.vxe-footer--row .col-red {
  background-color: rgb(32, 11, 219);
  color: #fff;
}

.mytable-footer .vxe-body--row.row-green {
  background-color: #187;
  color: #2db7f5;
}

.mytable-footer .vxe-header--column.col-blue {
  background-color: #2db7f5;
  color: #fff;
}

.mytable-footer .vxe-body--column.col-red {
  color: #f00;
}

.mytable-footer .vxe-body--column.col-orange {
  color: #f60;
}

.mytable-footer .vxe-body--column.col-green {
  color: rgb(29, 47, 202);
}
</style>

<style scoped>
.oeder_num_box {
  position: relative;
  display: flex;
  align-items: center;
}

.icon_yu {
  /* position: absolute;
  top: 0px;
  right: 0px; */
  width: 20px;
  height: 20px;
}

.icon_yu_big {
  /* position: absolute;
  top: 0px;
  right: 0px; */
  width: 24px;
  height: 24px;
}

::v-deep .vxe-table--footer-wrapper.body--wrapper::-webkit-scrollbar {
  -webkit-appearance: none;
  /* 禁用默认样式 */
  height: 12px !important;
  /* 设置滚动条高度（常驻显示） */
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

::v-deep .vxe-table--footer-wrapper.body--wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important;
  /* 滑块颜色 */
  border-radius: 5px !important;
  /* 滑块圆角 */
}

/* 针对微信浏览器定制滚动条 */
::v-deep
  .vxe-table:not(.is--empty).show--foot.scroll--x
  .vxe-table--body-wrapper::-webkit-scrollbar {
  -webkit-appearance: none;
  /* 禁用默认样式 */
  height: 12px !important;
  /* 设置滚动条高度（常驻显示） */
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

::v-deep
  .vxe-table:not(.is--empty).show--foot.scroll--x
  .vxe-table--body-wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important;
  /* 滑块颜色 */
  border-radius: 5px !important;
  /* 滑块圆角 */
}

.modify-amount-content {
  padding: 20px;
  box-sizing: border-box;
}

.original-amount {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4e7ed;
}

.modify-form {
  margin-bottom: 24px;
}

.modify-form :deep(.el-form-item) {
  margin-bottom: 16px;
}

.modify-form :deep(.el-form-item__label) {
  font-weight: 500;
  color: #606266;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #e4e7ed;
}
</style>
